import { Alert, Box, Container, Grid, Snackbar, Typography } from "@mui/material";
import './Finalizar.css';
import ReingresarCelular from "./PopupCelular";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Importar el hook de navegación

interface OkRequestSnack {
  open: boolean;
  message: string;
  severity: string;
}

const CustomizedSnackbars: React.FC<{ okRequest: OkRequestSnack }> = ({ okRequest }) => {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setOpen(okRequest.open);
  }, [okRequest]);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
      {/* <Alert onClose={handleClose} severity={okRequest.severity} variant="filled" sx={{ width: '100%' }}>
        {okRequest.message}
      </Alert> */}
    </Snackbar>
  );
};

function FinTarjetas() {
  const [OkRequest, setOkRequest] = React.useState<OkRequestSnack>({
    open: false,
    message: "",
    severity: 'success'
  });


  return (
    <>
      {OkRequest ? <CustomizedSnackbars okRequest={OkRequest} /> : null}
      <Container maxWidth="md" sx={{ marginTop: "10vh", marginBottom: { sx: '300px', md: '0px' } }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} textAlign={"center"} style={{ marginTop: '10px' }}>
            <Typography variant="h4" textAlign="center" sx={{ fontWeight: 700 }}>
              Revisá tu teléfono
            </Typography>
          </Grid>

          <Grid item xs={12} textAlign="center">
            <Box width="75%" sx={{ margin: "auto" }}>
              <Typography variant="body1" sx={{ textAlign: 'center', fontWeight: 500 }}>
                Para finalizar la solicitud de tu tarjeta de crédito tenemos que validar tu identidad.
                Te hemos enviado un link por SMS al teléfono, por favor continúa con el proceso.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} style={{ marginTop: '25px' }}>
            <ReingresarCelular onSetOkResponse={setOkRequest} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default FinTarjetas;
